import axios from 'axios';
import getOtmmUrl from '../../otmm/functions/getOtmmUrl';

export default axios.create({
  baseURL: getOtmmUrl('/otmmapi/v5/sessions'),
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
